import axios, { AxiosResponse } from 'axios';
import { action } from 'typesafe-actions';
import { apiUrl } from './../..';
import { alertError } from './../alert/actions';
import { Season, SeasonActionTypes, SeasonCreate } from './types';

export const getSeasons = (reqSectionTitle: string) => {
  const fetchRequest = () => action(SeasonActionTypes.FETCH_REQUEST);
  const fetchSuccess = (data: Season[], sectionTitle: string) =>
    action(SeasonActionTypes.FETCH_SUCCESS, { data, sectionTitle });
  const fetchError = (error: Error) => action(SeasonActionTypes.FETCH_ERROR, error);

  interface Response {
    id: number;
    seasons: Season[];
    title: string;
  }

  return (dispatch: any) => {
    dispatch(fetchRequest());

    const formatedTitle = encodeURI(reqSectionTitle.toLowerCase());

    axios
      .get(apiUrl + '/section/' + formatedTitle)
      .then((res: AxiosResponse<Response>) => {
        const seasons = res.data.seasons.map((season: Season) => {
          season.sectionTitle = reqSectionTitle;
          return season;
        });
        dispatch(fetchSuccess(seasons, reqSectionTitle));



        dispatch(action(SeasonActionTypes.CHECK_CURRENT_SEASON, reqSectionTitle));
      })
      .catch(err => {
        dispatch(fetchError(err));
        dispatch(alertError(err));
      });
  };
};

export const updateSeason = (season: Season, reqSectionTitle: string, successCB: () => any) => {
  const fetchRequest = () => action(SeasonActionTypes.FETCH_REQUEST);
  const fetchSuccess = (data: Season, sectionTitle: string) =>
    action(SeasonActionTypes.UPDATE_SUCCESS, { data, sectionTitle });
  const fetchError = (error: Error) => action(SeasonActionTypes.FETCH_ERROR, error);

  interface Response {
    season: Season;
  }

  return (dispatch: any) => {
    dispatch(fetchRequest());

    axios
      .put(apiUrl + '/season/', { season })
      .then((res: AxiosResponse<Response>) => {
        const resSeason = res.data.season;
        resSeason.sectionTitle = reqSectionTitle;
        dispatch(fetchSuccess(resSeason, reqSectionTitle));
        successCB();
      })
      .catch(err => {
        dispatch(fetchError(err));
        dispatch(alertError(err));
      });
  };
};

export const deleteSeason = (season: Season, reqSectionTitle: string) => {
  const fetchRequest = () => action(SeasonActionTypes.FETCH_REQUEST);
  const fetchSuccess = (data: Season, sectionTitle: string) =>
    action(SeasonActionTypes.DELETE_SUCCESS, { data, sectionTitle });
  const fetchError = (error: Error) => action(SeasonActionTypes.FETCH_ERROR, error);

  interface Response {
    season: Season;
  }

  return (dispatch: any) => {
    dispatch(fetchRequest());

    axios
      .delete(apiUrl + '/season/' + season.id)
      .then((res: AxiosResponse<Response>) => {
        const resSeason = res.data.season;
        resSeason.sectionTitle = reqSectionTitle;
        dispatch(fetchSuccess(resSeason, reqSectionTitle));
      })
      .catch(err => {
        dispatch(fetchError(err));
        dispatch(alertError(err));
      });
  };
};

export const createSeason = (
  season: SeasonCreate,
  reqSectionTitle: string,
  successCB: () => any
) => {
  const fetchRequest = () => action(SeasonActionTypes.FETCH_REQUEST);
  const fetchSuccess = (data: Season, sectionTitle: string) =>
    action(SeasonActionTypes.CREATE_SUCCESS, { data, sectionTitle });
  const fetchError = (error: Error) => action(SeasonActionTypes.FETCH_ERROR, error);

  interface Response {
    season: Season;
  }

  return (dispatch: any) => {
    dispatch(fetchRequest());

    axios
      .post(apiUrl + '/season/create', { ...season })
      .then((res: AxiosResponse<Response>) => {
        const resSeason = res.data.season;
        resSeason.sectionTitle = reqSectionTitle;
        dispatch(fetchSuccess(resSeason, reqSectionTitle));
        successCB();
      })
      .catch(err => {
        dispatch(fetchError(err));
        dispatch(alertError(err));
      });
  };
};

export const toggleSeason = (sectionTitle: string, id: number) => {
  return (dispatch: any) => dispatch(action(SeasonActionTypes.TOGGLE_SEASON, {sectionTitle, id}));
};

export const checkCurrentSeason = (sectionTitle: string) => {
  return (dispatch: any) => {
    dispatch(action(SeasonActionTypes.CHECK_CURRENT_SEASON, sectionTitle));
  };
};



// WEBPACK FOOTER //
// ./src/store/season/actions.ts